<template>
 <nav>

  <v-toolbar flat app :height="logoSize" color="lash">
    <v-avatar :tile="tile" :size="logoSize" class=""> <!-- class="mt-4" FOR ADMIN -->
          <img :src="require('@/image/logo.png')" alt="logo lashinstyle">
    </v-avatar>

    <v-spacer></v-spacer> <v-spacer v-show="!show" class="hidden-sm-and-down"></v-spacer>

    <v-toolbar-title block :class="titleSize">
        <v-layout row wrap text-xs-center>
          <v-flex>
            <div :class="{'mt-2': $vuetify.breakpoint.smAndDown,
                          'pr-5 pb-4': $vuetify.breakpoint.smAndDown, 
                          'pl-5 pb-4': $vuetify.breakpoint.mdAndUp,
                          'mt-3 pl-5': $vuetify.breakpoint.lgAndUp}"
                 class="justify-sm-center font-weight-regular">
                 Appuntamenti <br class="hidden-sm-and-up"> Lash<b>In</b>Style</div>
          </v-flex>
        </v-layout>      
    </v-toolbar-title>

    <v-spacer></v-spacer> 

    <Login  :style="{width: '0px'}" class="px-0 mx-0 hidden-sm-and-down" v-show="!show"> </Login>   
    <Signup :style="{width: '0px'}" class="px-0 mx-0 hidden-sm-and-down" v-show="!show"> </Signup>
    <v-btn flat left color="black" class="px-0 mx-0 hidden-sm-and-down" v-show="show" @click="logOut">
      <span>Log Out</span>
      <v-icon right>exit_to_app</v-icon>
    </v-btn> 
     <!-- <Createadmin class="hidden-sm-and-down" v-show="showAdmin"> </Createadmin> -->

    <template v-if="showAdmin || $vuetify.breakpoint.smAndDown" v-slot:extension>
      <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer=!drawer"></v-toolbar-side-icon>
      <v-tabs fixed-tabs color="lash" class="hidden-sm-and-down">
        <v-tabs-slider color="grey darken-4"></v-tabs-slider>
        <v-tab class="subheading font-weight-medium px-3" v-for="sezione in sezioni" :key="sezione.route" router :to="sezione.route">
          <v-icon class="mr-1">{{sezione.icon}}</v-icon>
          {{ sezione.voce }}
        </v-tab>
      </v-tabs>
    </template>

  </v-toolbar>

  <v-navigation-drawer app v-model="drawer" class="lash">

    <v-list v-if="showAdmin">
      <v-list-tile v-for="sezione in sezioni" :key="sezione.voce" router :to="sezione.route">
        <v-list-tile-action>
          <v-icon>{{sezione.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ sezione.voce }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>

    <v-list>
      <Login v-show="!show"> </Login>   
      <Signup v-show="!show"> </Signup>
      <v-btn flat left v-show="show" color="black" @click="logOut">
        <span>Log Out</span>
        <v-icon right>exit_to_app</v-icon>
      </v-btn> 
       <!-- <Createadmin class="hidden-sm-and-down" v-show="showAdmin"> </Createadmin> -->
    </v-list>

  </v-navigation-drawer>

 </nav>
</template>

<script>
import fb from "@/fb"
import Login from "./Login.vue"
import Signup from "./Signup.vue"
import EventBus from '../eventBus'
//import Createadmin from "./Createadmin.vue"

export default {
  components: {
      Login,
      Signup
  //    Createadmin
  },
  data() {
    return {
      drawer: false,
      tile: true,
      show: false,
      showAdmin: false,
      sezioni: [
        {voce:"Home", route:"/", icon:"home"},
        {voce:"Lashmaker's", route:"/lashmaker", icon:"face"},
        {voce:"Servizi", route:"/servizi", icon:"build"},
        {voce:"Impostazioni", route:"/impostazioni", icon:"build"},
        {voce:"Calendario", route:"/calendario", icon:"calendar_today"}
      ]
    }
  },
  methods: {
    logOut() {
      fb.auth.signOut().then(() => {
        this.showAdmin = false
        if (this.$route.path == "/") {
          this.$router.go("/")
        } else {
          this.$router.replace("/")
        }       
      })
    }
  },
  computed: {
// eslint-disable-next-line
    titleSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 'headline pt-4 mt-5'
        case 'sm': return 'display-1 pt-4 mt-5'
        case 'md': return 'display-1 mt-4'
        case 'lg': return 'display-2'
        case 'xl': return 'display-2'
      }
    },
// eslint-disable-next-line
    logoSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '60px'
        case 'sm': return '60px'
        case 'md': 
        if (this.showAdmin) {     
          return '80px'
        } else {
          return '60px'
        }      
        case 'lg': return '80px'
        case 'xl': return '80px'
        
      }
    }  
  },
  beforeCreate: function () {
    fb.auth.onAuthStateChanged(user => {
      if (user) {
        user.getIdTokenResult().then(idTokenResult => {
          if (idTokenResult.claims.admin == true) {
            this.showAdmin = true
          } else {
            this.showAdmin = false
          }
        })
        this.show = true
        //console.log("loggato")
      } else {
        this.show = false
        //console.log("non loggato")
      }
    }) 
  }, 
  mounted() {
    EventBus.$on("login-effettuato", () => {
      this.drawer = false }
    )
  }
}
</script>

<style>
.primary--text.v-list__tile--active{font-size: 145%!important; color: black!important;}
</style>
